import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { bootstrapQueryOptions } from '@/features/bootstrap/api/bootstrap/queries/bootstrap-query'
import {
  getNoWorkspacesEntryRoute,
  shouldRedirectToNoWorkspaceEntry,
} from '@/features/bootstrap/domain/bootstrap-entry'
import WorkspaceSettingsPage from '@/pages/workspace/settings'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { setLastWorkspaceId } from '@/shared/lib/last-workspace'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectWorkspaceToGtm } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  tab: z
    .enum(['general', 'plugins', 'members', 'docs', 'rules', 'audit'])
    .optional(),
})

export type WorkspaceSettingsSearch = z.infer<typeof searchSchema>

export const Route = createFileRoute('/$lang/workspace/$workspaceId/settings')({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: async ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      await redirectWorkspaceToGtm(context, params, 'settings')
    }
    requireAuthenticated(context, params)
    setLastWorkspaceId(params.workspaceId)

    const bootstrap = await context.queryClient.ensureQueryData(
      bootstrapQueryOptions(),
    )
    if (shouldRedirectToNoWorkspaceEntry(bootstrap)) {
      throw redirect({
        to: getNoWorkspacesEntryRoute(bootstrap),
        params: { lang: params.lang },
        replace: true,
      })
    }
  },
  component: WorkspaceSettingsPage,
  staticData: { layout: 'main' },
})
